import { makeStyles } from '@mui/styles';
import { COLOR_PURPLE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  primaryColor: {
    color: COLOR_PURPLE,
  },
  mainContentBox: {
    backgroundColor: theme.palette.common.white,
    borderRadius: 6,
    boxShadow: '0px 3px 6px #00000029',
  },
  list: {
    listStyleType: 'none',

    '& li': {
      fontSize: 18,
      fontWeight: 'bold',
      padding: theme.spacing(1, 0),
    },
  },
  verticalDivider: {
    height: 165,
    width: 1,
    margin: theme.spacing(0, 1, 0, 4),
  },
}));
